<template>
  <div>
     <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="28px"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col> -->
        <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                class="ml-7 header_btn"
              >
                <v-icon size="28px"> mdi-file-plus-outline </v-icon>
                <span class="lable_class">Add</span>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                class="ml-7 header_btn"
              >
                <v-icon size="28px"> mdi-clipboard-edit-outline </v-icon>
                <span class="lable_class">Edit</span>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled
              class="ml-7 header_btn">
                <v-icon size="28px"> mdi-eye-outline </v-icon>
                <span class="lable_class">View</span>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                class="ml-7 header_btn" 
              >
                <v-icon size="28px"> mdi-delete-outline </v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>
        <v-col cols="6">
           <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small dark v-bind="attrs" v-on="on" class="header_btn">
                 <span class="lable_class">Search</span>
                 <v-badge overlap dot :value="search" color="error">
                  <v-icon size="28px">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="300">
              <v-row no-gutters>
            <v-col cols="12" class="">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                dense
                solo
                clearable
                v-on:keyup.enter="search_menu = false"
                autofocus
              ></v-text-field>
            </v-col>
          </v-row>
            </v-card>
           </v-menu>
           <v-menu bottom :close-on-content-click="false" content-class="elevation-0" v-model="filter_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on" class="ml-7 header_btn">
                  <v-icon size="22px">mdi-filter-menu-outline</v-icon>
                  <span class="lable_class">Filter</span>
              </v-btn>
            </template>
            <v-card tile max-width="310" class="mb-5 mr-5">
              <v-list class="filter-section-border">
                <v-list-item>
                  <v-autocomplete
                    dense
                    :items="user_list"
                    outlined
                    label="Type"
                    hide-details
                    placeholder="All"
                    v-model="pagination.filters.user_id"
                    item-text="full_name"
                    item-value="user_id"
                    clearable=""
                  ></v-autocomplete>
                </v-list-item>
              </v-list>
              <v-card-title class="pa-0">
                  <v-btn
                    fab
                    color="error"
                    x-small
                    absolute
                    @click="filter_menu = false"
                    class="custom-close-btn"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>

            </v-card>
          </v-menu>
        </v-col>
        <v-col cols="3" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">Login Logs
            <v-icon class="error--text ml-2" size="30" style="color:#ffffff !important" @click="logout()" >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
          <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
        </v-overlay>
    <v-card flat tile>
      
      <v-card-text
        class="pa-0 mx-auto"
      >
        <v-data-table
          :headers="headers"
          class="elevation-1 rounded-0 my-transaction-table small-table fix-table-layout fix-table-header"
          item-key="user_login_log_id"
          :search="search"
          :items="items.data"
          :server-items-length="items.total"
          :options.sync="pagination"
          mobile-breakpoint="50"
          dense
          :footer-props="{
            'items-per-page-options': pagination_settings.perPageList,
          }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td width="15%">
                {{item.user_data.full_name}}
              </td>
              <td width="15%">
                {{(item.user_data.email_domain)?item.user_data.email+'@'+item.user_data.email_domain.domain:''}}
              </td>
              <td width="10%">
                {{item.created_at}}
              </td>
              <td width="10%">
                {{item.ip}}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { parseParams, logout} from "../../plugins/helper";
import { mapState } from "vuex";
export default {
  name: "Area",
  data() {
    return {
      search: "",
      loading: false,
      user_list: [],
      filter_menu: false,
      items: {
        data: [],
      },
      headers: [
        { value: "", text: "User Name", sortable: false, width: '15%' },
        { value: "", text: "Emain", sortable: false, width: '15%' },
        { value: "", text: "Login Date & Time", sortable: false, width: '10%' },
        { value: "", text: "IP Address", sortable: false, width: '10%' },
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["created_at"],
        page: 1,
        filters: {
          user_id: "",
        },
      },
      search_menu : false
    };
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "first_name";
      return paginationData;
    },
  },
  watch: {
    search() {
      this.getRecords();
    },
    pagination: {
      handler: function () {
        this.getRecords();
      },
      deep: true,
    },
  },
  methods: {
    getRecords() {
      let _self = this;
      this.loading = "accent";
      let url = parseParams(this.pageData);
      axios.get("login_log_list?" + url)
        .then((response) => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          _self.loading = false;
        })
        .catch(function () {
          _self.loading = false;
        });
    },
    getUsers() {
      this.loading = false
      let _self = this;
      axios
        .get("user_list?itemsPerPage=-1")
        .then((response) => {
          console.log(response)
          _self.user_list = response.data.data.data;
          _self.loading = false
        })
        .catch(function () {
          _self.loading = false
        });
    },
    logout() {
      logout(this.$router)
    }
  },
  mounted() {
    this.getRecords();
    this.getUsers();
  },
};
</script>